import { render, staticRenderFns } from "./ProfileListItem.vue?vue&type=template&id=4b6f6960&"
import script from "./ProfileListItem.vue?vue&type=script&lang=js&"
export * from "./ProfileListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports